"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Creates an error with an optional http status code.
 *
 * @param message - The error message.
 * @param status - The HTTP status code. Defaults to 400.
 * @returns An error
 */
function validationError(message, status = 400) {
    return Object.assign(new Error(message), { status });
}
exports.default = validationError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsaWRhdGlvbkVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL3ZhbGlkYXRpb25FcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBOzs7Ozs7R0FNRztBQUNILFNBQXdCLGVBQWUsQ0FDckMsT0FBZSxFQUNmLFNBQWlCLEdBQUc7SUFFcEIsT0FBTyxNQUFNLENBQUMsTUFBTSxDQUFDLElBQUksS0FBSyxDQUFDLE9BQU8sQ0FBQyxFQUFFLEVBQUUsTUFBTSxFQUFFLENBQUMsQ0FBQztBQUN2RCxDQUFDO0FBTEQsa0NBS0MifQ==